type StatusBarStyle = 'dark-content' | 'default' | 'light-content';

const light = {
  style: 'dark-content' as StatusBarStyle,
};

const dark = {
  style: 'light-content' as StatusBarStyle,
};

export const statusBar: {dark: StatusBar; light: StatusBar} = {
  dark,
  light,
};

type StatusBar = typeof light;
